import React, { forwardRef, ForwardedRef } from 'react';
import { GroupSubLabelWrapper, GroupSubLabelText } from './atoms';

type GroupSubLabelElementArgs = { groupSublabel: string };
export const GroupSubLabel = forwardRef(
  (
    { groupSublabel }: GroupSubLabelElementArgs,
    ref: ForwardedRef<HTMLDivElement>
  ) => (
    <GroupSubLabelWrapper ref={ref}>
      {'('}
      <GroupSubLabelText>{groupSublabel}</GroupSubLabelText>
      {')'}
    </GroupSubLabelWrapper>
  )
);
